/**
 * Footer Cookie settings + make Shopify native banner buttons apply consent.
 * Does not change Shopify banner CSS or layout.
 */
(function () {
  var lastActionAt = 0;
  var ACK_KEY = 'iw_cookie_banner_ack';

  function hasBannerAck() {
    try {
      return window.localStorage.getItem(ACK_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markBannerAck() {
    try {
      window.localStorage.setItem(ACK_KEY, '1');
    } catch (e) {}
  }

  // Shopify already recorded "yes" for browsers that hit the old auto-prime. Updating the
  // theme does not erase that, so the native banner stays gone after refresh. Ask Shopify
  // to load it again until the visitor actually clicks Accept / Save / Decline.
  function requestNativeBanner() {
    if (hasBannerAck()) return true;
    if (document.getElementById('shopify-pc__banner')) return true;
    if (window.privacyBanner && typeof window.privacyBanner.loadBanner === 'function') {
      try {
        window.privacyBanner.loadBanner();
      } catch (e) {}
    }
    return false;
  }

  var bannerTries = 0;
  var bannerTimer = window.setInterval(function () {
    bannerTries += 1;
    if (requestNativeBanner() || bannerTries > 20) {
      window.clearInterval(bannerTimer);
    }
  }, 250);

  // Business ask: delay the initial banner's visual appearance by a few seconds so it
  // doesn't pop up the instant the page loads. This only hides it with CSS (opacity +
  // pointer-events) - the banner's own script stays fully loaded and functional the whole
  // time (see FAST_RE in snippets/perf-defer-script.liquid), so this does not reintroduce
  // the "needs 2 clicks" bug that gating the script itself caused.
  var POPUP_DELAY_MS = 4000;
  var hideBannerStyle = document.createElement('style');
  hideBannerStyle.textContent =
    '#shopify-pc__banner{opacity:0!important;pointer-events:none!important;transition:none!important;}';
  (document.head || document.documentElement).appendChild(hideBannerStyle);
  setTimeout(function () {
    if (hideBannerStyle.parentNode) hideBannerStyle.parentNode.removeChild(hideBannerStyle);
  }, POPUP_DELAY_MS);

  function privacy() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  // window.Shopify.customerPrivacy is only ready after the async
  // Shopify.loadFeatures(consent-tracking-api) call in theme.liquid resolves. A click that
  // lands before that finishes previously no-op'd silently, so the choice looked lost and
  // needed a second click to "take". Now the latest requested values are retried until the
  // API is ready, so the first click's choice is never dropped.
  var pendingConsent = null;
  var pendingRetryTimer = null;

  function applyPendingConsent() {
    var api = privacy();
    if (!api || typeof api.setTrackingConsent !== 'function') return false;
    if (pendingConsent) {
      api.setTrackingConsent(pendingConsent);
      pendingConsent = null;
    }
    return true;
  }

  function setTrackingConsent(values) {
    pendingConsent = {
      analytics: values.analytics !== false,
      marketing: values.marketing !== false,
      preferences: values.preferences !== false,
    };
    if (applyPendingConsent()) return;
    if (pendingRetryTimer) return;
    var attempts = 0;
    pendingRetryTimer = setInterval(function () {
      attempts++;
      if (applyPendingConsent() || attempts > 50) {
        clearInterval(pendingRetryTimer);
        pendingRetryTimer = null;
      }
    }, 200);
  }

  function prefsRoot() {
    return document.getElementById('shopify-pc__prefs__dialog') || document.getElementById('shopify-pc__prefs');
  }

  function checkboxIn(root, keys) {
    if (!root) return null;
    var inputs = root.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < inputs.length; i++) {
      var hay = ((inputs[i].id || '') + ' ' + (inputs[i].name || '')).toLowerCase();
      for (var k = 0; k < keys.length; k++) {
        if (hay.indexOf(keys[k]) !== -1) return inputs[i];
      }
    }
    return null;
  }

  function readPrefs() {
    var root = prefsRoot();
    var marketing = checkboxIn(root, ['marketing']);
    var analytics = checkboxIn(root, ['analytics']);
    var preferences = checkboxIn(root, ['personalization', 'preferences']);
    return {
      marketing: marketing ? marketing.checked : true,
      analytics: analytics ? analytics.checked : true,
      preferences: preferences ? preferences.checked : true,
    };
  }

  function grantAllCheckboxes() {
    var scope = prefsRoot();
    if (!scope) return;
    var boxes = scope.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (box.disabled || box.checked) continue;
      box.checked = true;
      box.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function actionFromEvent(event) {
    var target = event.target;
    if (!target || !target.closest) return null;
    if (!target.closest('#shopify-pc__banner, #shopify-pc__prefs, #shopify-pc__prefs__dialog')) {
      return null;
    }
    if (target.closest('#shopify-pc__banner__btn-accept, #shopify-pc__prefs__header-accept')) {
      return 'accept';
    }
    if (target.closest('#shopify-pc__prefs__header-save')) return 'save';
    if (target.closest('#shopify-pc__banner__btn-decline, #shopify-pc__prefs__header-decline')) {
      return 'decline';
    }
    return null;
  }

  function runAction(action) {
    var now = Date.now();
    if (now - lastActionAt < 400) return;
    lastActionAt = now;
    markBannerAck();
    if (action === 'accept') {
      grantAllCheckboxes();
      setTrackingConsent({ analytics: true, marketing: true, preferences: true });
    } else if (action === 'save') {
      setTrackingConsent(readPrefs());
    } else if (action === 'decline') {
      setTrackingConsent({ analytics: false, marketing: false, preferences: false });
    }
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('a[data-cookie-settings="true"]')) {
      event.preventDefault();
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
      }
      return;
    }

    var action = actionFromEvent(event);
    if (!action) return;
    runAction(action);
  });

  // Deferred (not synchronous in the MutationObserver callback) so Shopify's own dialog-open
  // handling finishes attaching its listeners first. Priming and a real user click landing in
  // the same tick was the likely cause of "Save" needing a second click to register.
  var didPrimeCheckboxes = false;
  var observer = new MutationObserver(function () {
    var dialog = document.getElementById('shopify-pc__prefs__dialog');
    var open = dialog && (dialog.open || dialog.hasAttribute('open'));
    if (open && !didPrimeCheckboxes) {
      didPrimeCheckboxes = true;
      setTimeout(function () {
        // Skip if the user has already acted (e.g. clicked Save) since the dialog opened.
        if (Date.now() - lastActionAt < 500) return;
        grantAllCheckboxes();
      }, 0);
    }
    if (!open) didPrimeCheckboxes = false;
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
